import { IIncident, INCIDENTS_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway } from '../gateways';

export class IncidentMonitorGateway implements IGetGateway<
  null,
  IApiResponse<IIncident[]>
> {
  private readonly restCallBuilder: RestCallBuilder<IIncident[]> =
    new RestCallBuilder<IIncident[]>([]);

  get(): Observable<IApiResponse<IIncident[]>> {
    return this.restCallBuilder
      .get('/incident-monitor/')
      .validate(API_RESPONSE_SCHEMA(INCIDENTS_SCHEMA), 'Incident.get')
      .handleMessages()
      .build();
  }
}
